import React from "react";
const Dashboard = React.lazy(() => import("./components/dashboard/Dashboard"));
const FlujoCaja = React.lazy(() => import("./components/flujocaja/FlujoCaja"));
const Creditos = React.lazy(() => import("./components/creditos/Creditos"));
const DocumentosTributarios = React.lazy(() =>
  import("./components/documentostributarios/DocumentosTributarios")
);
const Proveedores = React.lazy(() =>
  import("./components/proveedores/Proveedores")
);
const Agenda = React.lazy(() => import("./components/agenda/Agenda"));
const Conexiones = React.lazy(() =>
  import("./components/conexiones/Conexiones")
);
const Reportes = React.lazy(() => import("./components/reportes/Reportes"));
const ReportesDJ = React.lazy(() => import("./components/reportes/ReportesDJ"));
const Eerr = React.lazy(() => import("./components/EERR(new)"));
// const Conciliacion = React.lazy(() =>
//   import("./components/conciliacion/Conciliacion")
// );
const Conciliacion2 = React.lazy(() =>
  import("./components/transactions(new)")
);
const Usuarios = React.lazy(() => import("./components/usuarios/Usuarios"));
const Cobranza = React.lazy(() => import("./components/cobranza"));
const F29 = React.lazy(() => import("./components/f29"));
const Configuracion = React.lazy(() => import("./components/configuracion/Configuracion"));
const Logout = React.lazy(() => import("./components/login/Logout"));
const Suscripcion = React.lazy(() => import("./components/suscripcion"));
const Eoaf = React.lazy(() => import("./components/EOAF"));
const Cuadratura = React.lazy(() => import("./components/cuadratura" ))


const routes = [
  { path: "/", exact: true, name: "Home", pageTitle: "Home" },
  { path: "/dashboard", name: "Dashboard", component: Dashboard, pageTitle: "Dashboard" },
  { path: "/flujo_caja", name: "FlujoCaja", component: FlujoCaja, pageTitle: "Flujo de Caja" },
  { path: "/eerr", name: "Estado de Resultados", component: Eerr, pageTitle: "Estado de Resultados" },
  {
    path: "/documentos_tributarios",
    name: "DocumentosTributarios",
    component: DocumentosTributarios,
    pageTitle: "Documentos"
  },
  { path: "/creditos", name: "Creditos", component: Creditos, pageTitle: "Préstamos" },
  { path: "/pago_proveedores", name: "Proveedores", component: Proveedores, pageTitle: "Pago a Proveedores" },
  { path: "/cuadratura", name: "Cuadratura", component: Cuadratura, pageTitle: "Cuadratura" },
  { path: "/agenda", name: "Agenda", component: Agenda, pageTitle: "Agenda" },
  { path: "/conciliacion", name: "Conciliación Bancaria", component: Conciliacion2, pageTitle: "Conciliación Bancaria" },
  { path: "/conexiones", name: "Conexiones", component: Conexiones, pageTitle: "Conexiones" },
  { path: "/reportes", name: "Reportes", component: Reportes, pageTitle: "Reportes" },
  { path: "/reportes_dj", name: "Reportes DJ", component: ReportesDJ, pageTitle: "Reportes DJ" },
  { path: "/usuarios", name: "Usuarios", component: Usuarios, pageTitle: "Usuarios" },
  { path: "/cobranza", name: "Cobranza Online", component: Cobranza, pageTitle: "Cobranza" },
  { path: "/f-29", name: "Propuesta F-29", component: F29, pageTitle: "Propuesta F-29" },
  { path: "/configuracion", name: "Configuración", component: Configuracion, pageTitle: "Configuración" },
  { path: "/suscripcion", name: "Suscripción", component: Suscripcion},
  { path: "/logout", name: "Logout", component: Logout },
  { path: "/eoaf", name: "EOAF", component: Eoaf, pageTitle:"Estado de Origen y Aplicación de Fondos" },
];

export default routes;
